import React from 'react';
import FigmaButton from '../FigmaButton';
import ButtonColorsEnum from '../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../Enums/IconPositionEnum';

// The footer button that closes a window: "Cancel" before anything is done, "Close" after it.
export default function DialogCloseButton({ label = 'Close', disabled = false, onClick = () => {} }) {
  return (
    <FigmaButton
      label={label}
      iconName='fa-solid fa-xmark'
      iconPosition={IconPositionEnum.Left}
      color={ButtonColorsEnum.Common}
      type={ButtonTypeEnum.NormalNormal}
      disabled={disabled}
      onClick={onClick}
    />
  );
}
